import { z } from 'zod';

export const stripePaymentSchema = z.object({
  country: z.string().trim().min(1, { message: 'Country is required' }),
  postalCode: z.string().trim().min(1, { message: 'Postal code is required' }),
  cardName: z.string().trim().min(1, { message: 'Card name is required' }),
});

export const affirmPaymentSchema = z.object({
  country: z.string().trim().min(1, { message: 'Country is required' }),
  postalCode: z.string().trim().min(1, { message: 'Postal code is required' }),
  state: z.string().trim().min(1, { message: 'State is required' }),
  city: z.string().trim().min(1, { message: 'City is required' }),
  address1: z.string().trim().min(1, { message: 'Address is required' }),
});
